var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "elevation-2 app-drawer",
      attrs: {
        "mini-variant-width": 50,
        "mobile-breakpoint": "991",
        "mini-variant": _vm.miniDrawer,
        width: _vm.miniDrawer ? 50 : 270,
        clipped: "",
        app: "",
      },
      scopedSlots: _vm._u([
        {
          key: "append",
          fn: function () {
            return [
              _c("v-divider"),
              _c(
                "div",
                {
                  staticClass: "d-flex",
                  staticStyle: {
                    "justify-content": "center",
                    "align-items": "center",
                    height: "40px",
                  },
                },
                [
                  _c(
                    "v-btn",
                    { attrs: { icon: "" }, on: { click: _vm.miniHandler } },
                    [
                      _c("v-icon", [
                        _vm._v(
                          _vm._s(
                            _vm.miniDrawer ? "chevron_right" : "chevron_left"
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.$store.state.drawer,
        callback: function ($$v) {
          _vm.$set(_vm.$store.state, "drawer", $$v)
        },
        expression: "$store.state.drawer",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "order-service",
          class: { "order-service--mini": _vm.miniDrawer },
        },
        [
          _c(
            "v-menu",
            {
              attrs: {
                "offset-y": "",
                "offset-x": _vm.miniDrawer,
                "nudge-bottom": 6,
                "nudge-right": _vm.miniDrawer ? 8 : 0,
                "min-width": "228",
                "max-width": "260",
                "content-class": "order-service-menu",
                transition: "slide-y-transition",
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    return [
                      _c(
                        "button",
                        _vm._g(
                          {
                            staticClass: "order-service__btn",
                            class: { "is-open": _vm.orderMenuOpen },
                            attrs: {
                              type: "button",
                              title: _vm.$t("btn_add[1]"),
                            },
                          },
                          on
                        ),
                        [
                          _c(
                            "span",
                            { staticClass: "order-service__plus" },
                            [_c("d-icon", { attrs: { value: "add" } })],
                            1
                          ),
                          !_vm.miniDrawer
                            ? _c(
                                "span",
                                { staticClass: "order-service__label" },
                                [_vm._v(_vm._s(_vm.$t("btn_add[0]")))]
                              )
                            : _vm._e(),
                          !_vm.miniDrawer
                            ? _c("d-icon", {
                                staticClass: "order-service__chevron",
                                attrs: { value: "arrow-s-down" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.orderMenuOpen,
                callback: function ($$v) {
                  _vm.orderMenuOpen = $$v
                },
                expression: "orderMenuOpen",
              },
            },
            [
              _c("div", { staticClass: "order-service-menu__panel" }, [
                _c("div", { staticClass: "order-service-menu__caption" }, [
                  _vm._v(_vm._s(_vm.$t("menu_caption"))),
                ]),
                _c(
                  "div",
                  { staticClass: "order-service-menu__list" },
                  _vm._l(_vm.orderMenus, function (item) {
                    return _c(
                      "router-link",
                      {
                        key: item.path,
                        staticClass: "order-service-menu__item",
                        class: { "has-rule": item.dividerBefore },
                        attrs: { to: item.path, exact: "" },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "order-service-menu__icon" },
                          [_c("d-icon", { attrs: { value: item.icon } })],
                          1
                        ),
                        _c(
                          "span",
                          { staticClass: "order-service-menu__name" },
                          [_vm._v(_vm._s(_vm.$t(item.text)))]
                        ),
                        _c("d-icon", {
                          staticClass: "order-service-menu__go",
                          attrs: { value: "arrow-right" },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "v-list",
        { attrs: { dense: "" } },
        [
          _vm._l(_vm.navMenus, function (menu, i) {
            return [
              menu.menus
                ? _c(
                    "v-list-group",
                    _vm._b(
                      {
                        key: menu.text,
                        attrs: {
                          "no-action": "",
                          title: menu.title ? _vm.$t(menu.title) : undefined,
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.expandDrawerIfMini($event)
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prependIcon",
                              fn: function () {
                                return [
                                  _c("d-icon", { staticClass: "fs-2" }, [
                                    _vm._v(_vm._s(menu.icon)),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "activator",
                              fn: function () {
                                return [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "menu-l1" },
                                    [_vm._v(_vm._s(_vm.menuLabel(menu)))]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      "v-list-group",
                      menu.bindAttrs,
                      false
                    ),
                    [
                      _vm._l(menu.menus, function (item, j) {
                        return [
                          item.menus
                            ? _c(
                                "v-list-group",
                                _vm._b(
                                  {
                                    key: item.text,
                                    attrs: {
                                      "sub-group": "",
                                      "no-action": "",
                                      title: item.title
                                        ? _vm.$t(item.title)
                                        : undefined,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-list-item-title",
                                                { staticClass: "menu-l2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.menuLabel(item))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  "v-list-group",
                                  item.bindAttrs,
                                  false
                                ),
                                _vm._l(item.menus, function (sub, k) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: k,
                                      attrs: {
                                        to: sub.path,
                                        "active-class": "nav-item-active",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "menu-l3" },
                                        [_vm._v(_vm._s(_vm.menuLabel(sub)))]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            : _c(
                                "v-list-item",
                                {
                                  key: j,
                                  attrs: {
                                    to: item.path,
                                    "active-class": "nav-item-active",
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "menu-l2" },
                                    [_vm._v(_vm._s(_vm.menuLabel(item)))]
                                  ),
                                ],
                                1
                              ),
                        ]
                      }),
                    ],
                    2
                  )
                : _c(
                    "v-list-item",
                    _vm._b(
                      {
                        key: i,
                        attrs: {
                          title: _vm.$t(menu.title),
                          "active-class": "nav-item-active",
                        },
                      },
                      "v-list-item",
                      menu.bindAttrs,
                      false
                    ),
                    [
                      _c(
                        "v-list-item-action",
                        [
                          _c("d-icon", { staticClass: "fs-2" }, [
                            _vm._v(_vm._s(menu.icon)),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", { staticClass: "menu-l1" }, [
                            _vm._v(_vm._s(_vm.menuLabel(menu))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }